module.exports = __webpack_public_path__ + "img/AC_S2_Header.705489eb.png";